var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlcDisconnectedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14141_138299)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 2V3H11.5V2C11.5 1.72386 11.7239 1.5 12 1.5C12.2761 1.5 12.5 1.72386 12.5 2V3H14.5V2C14.5 1.72386 14.7239 1.5 15 1.5C15.2761 1.5 15.5 1.72386 15.5 2V3H16.8C19.1196 3 21 4.8804 21 7.2V8.5L22 8.5C22.2761 8.5 22.5 8.72386 22.5 9C22.5 9.27614 22.2761 9.5 22 9.5H21V11.5H22C22.2761 11.5 22.5 11.7239 22.5 12C22.5 12.2761 22.2761 12.5 22 12.5H21V14.5H22C22.2761 14.5 22.5 14.7239 22.5 15C22.5 15.2761 22.2761 15.5 22 15.5H21V16.8C21 19.1196 19.1196 21 16.8 21H15.5V22C15.5 22.2761 15.2761 22.5 15 22.5C14.7239 22.5 14.5 22.2761 14.5 22V21H12.5V22C12.5 22.2761 12.2761 22.5 12 22.5C11.7239 22.5 11.5 22.2761 11.5 22V21H9.5V22C9.5 22.2761 9.27614 22.5 9 22.5C8.72386 22.5 8.5 22.2761 8.5 22V21H7.2C4.8804 21 3 19.1196 3 16.8V15.5H2C1.72386 15.5 1.5 15.2761 1.5 15C1.5 14.7239 1.72386 14.5 2 14.5H3V12.5H2C1.72386 12.5 1.5 12.2761 1.5 12C1.5 11.7239 1.72386 11.5 2 11.5H3V9.5H2C1.72386 9.5 1.5 9.27614 1.5 9C1.5 8.72386 1.72386 8.5 2 8.5H3V7.2C3 4.8804 4.8804 3 7.2 3H8.5V2C8.5 1.72386 8.72386 1.5 9 1.5C9.27614 1.5 9.5 1.72386 9.5 2ZM5 7.2C5 5.98497 5.98497 5 7.2 5H16.8C18.015 5 19 5.98497 19 7.2V16.8C19 18.015 18.015 19 16.8 19H7.2C5.98497 19 5 18.015 5 16.8V7.2ZM14.4 8C15.2837 8 16 8.71634 16 9.6V14.4C16 15.2837 15.2837 16 14.4 16H9.6C8.71634 16 8 15.2837 8 14.4V9.6C8 8.71634 8.71634 8 9.6 8H14.4Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.29289,
    y: 3,
    width: 3,
    height: 28,
    rx: 1.5,
    transform: "rotate(-45 1.29289 3)",
    fill: "currentColor",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14141_138299"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlcDisconnectedIcon);
export default __webpack_public_path__ + "static/media/plc-disconnected-icon.76a8033ce0dc7cd079acdcb2fe16a112.svg";
export { ForwardRef as ReactComponent };